import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import Table from '../../components/Table';

function Wastes() {
  const [wastes, setWastes] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);

  const columns = [
    {
      title: 'Ciclo',
      field: 'cycle.description',
      hideFilterIcon: true,
      editable: 'never',
    },
    {
      title: 'Insumo',
      field: 'supply.name',
      hideFilterIcon: true,
      editable: 'never',
    },
    {
      title: 'Quantidade',
      field: 'quantity',
      hideFilterIcon: true,
      render: (rowData) => (
        <span>{new Intl.NumberFormat('pt-BR').format(rowData.quantity)}</span>
      ),
    },
    {
      title: 'Data',
      field: 'date',
      type: 'date',
      hideFilterIcon: true,
      editable: 'never',
    },
    {
      title: 'Descrição',
      field: 'description',
      hideFilterIcon: true,
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/wastes');

        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          setWastes(response.data);
        }
      } catch (err) {

      }
    }
    loadData();
  }, []);

  function setData(newData) {
    const tempData = [];
    wastes.map((mortality) => (mortality.id === newData.id
      ? tempData.push(newData)
      : tempData.push(mortality)));
    setWastes(tempData);
  }

  return (
    <Table
      title="Perdas de Rações"
      route="/wastes/"
      routeAdd="/waste/"
      columns={columns}
      data={wastes}
      setData={setData}
      dataLoaded={openProgress}
    />
  );
}

export default Wastes;
